export default {
	store: 2,
	myDirection: 1,
};



// WEBPACK FOOTER //
// ./src/shared/PickUp.js